import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar,Tooltip, OverlayTrigger, Popover} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import store from "store2";
import FolderLookup from "../../components/Form/FolderLookup";

export default class List extends Component {

	constructor(props, context) {
		super(props);

		const rendererFiles = (val, row) => {
			const files = row.files.map(file => {
				const tooltip = <Tooltip id="file">{file.title}</Tooltip>
				return (
					<OverlayTrigger key={file.id} placement="top" overlay={tooltip}>
						<a style={{color:'#000'}} href={'/file/download/' + file.id}>
							<i style={{fontSize: 13}} className="glyphicon glyphicon-paperclip" />
						</a>
					</OverlayTrigger>
				)
			});
			return <div>
				{files}
			</div>
		};

		this.columnModel = [
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width:80,
				sortable: false,
				renderer: (val, row) => {
					return (<div style={{color:'#2196F3', cursor:'pointer'}} onClick={() => this.props.onAdd(row)}>
							<i className="fa fa-plus"></i> vybrat
						</div>
					);
				}
			},
			{
				name: 'files',
				width: 58,
				sortable:false,
				renderer: rendererFiles
			},
			{
				name: 'title',
				title: 'Název',
				field: 'title',
				renderer: (val, row) => {
					return <div style={{color:'#2196F3', cursor:'pointer'}} onClick={() => this.props.onAdd(row)}>{val}</div>;
				}
			},
			{
				name: 'fTitle',
				title: 'Složka',
				field: 'fTitle',
				width: 250
			},
			{
				name: 'published',
				title: 'Publ.',
				field: 'published',
				width: 50,
				renderer: Renderers.Check
			}
		];

		const filterSchema = {
			title: { class: FilterInput },
			fulltext: { class: SearchInput },
			fTitle: { class: FolderLookup },
			published: { class: Select, options: DbInfo.YesNo },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-documentpopup');
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'fTitle', 'direction': 'asc'};
	}


	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('document.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('document.change', this.changeListener);
	}

	getRowClassName(row) {
		return row.line ? 'rowline' : null;
	}

	render() {
		return (
			<Datagrid
				ref="datagrid"
				id="documentpopup"
				api="document.getList"
				buttons={<h5>Vyberte dokument</h5>}
				filters={['fulltext']}
				filter={this.filter}
				limit={20}
				saveState={false}
				getRowClassName={(row) => this.getRowClassName(row)}
				columnModel={this.columnModel}
				defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Document/PickerList.js